var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section col_w_3"},[_c('div',{staticClass:"section_wrap terms_of_use"},[_c('div',{staticClass:"section_title"},[_vm._v(_vm._s(_vm.$t('account.the_terms_use')))]),_c('vue-friendly-iframe',{attrs:{"src":_vm.agreementUrl1,"crossorigin":''}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }